export enum ProductDetailBannerType {
    Marketing = 'marketing',
    Loyalty = 'loyalty',
    GiftWithPurchase = 'gwp',
}
